module.exports = __webpack_public_path__ + "res/Roboto-Condensed-webfontd41d.eot?ffe16578a77e6da6d145cb39368fe6d6";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-Condensed-webfontd41d.eot
// module id = 32
// module chunks = 0